import moment from 'moment'

import { Icon } from 'src/app/types'
import { GetPaginatedGroupsData, MinimalContactFragment } from 'src/graphql'

export enum SearchFilterType {
  DATERANGE,
  BOOLEAN,
  GROUP,
  CONTACT,
}

interface SearchFilterBase {
  name: string
  type: SearchFilterType
  icon?: Icon
}

export interface DateSearchFilter extends SearchFilterBase {
  type: SearchFilterType.DATERANGE
  value?: {
    start: moment.Moment
    end: moment.Moment
  }
}

interface BooleanSearchFilter extends SearchFilterBase {
  type: SearchFilterType.BOOLEAN
  value?: boolean
}

interface GroupSearchFilter extends SearchFilterBase {
  type: SearchFilterType.GROUP
  value?: GetPaginatedGroupsData['paginatedGroups']['groups']
}

export interface ContactSearchFilter extends SearchFilterBase {
  type: SearchFilterType.CONTACT
  value?: MinimalContactFragment[]
}

export type SearchFilter =
  | DateSearchFilter
  | BooleanSearchFilter
  | GroupSearchFilter
  | ContactSearchFilter
